import { mutate } from "swr"

const AnnouncementsMutate: any = {
  FetchAnnouncementPosts: (activeTable: number) =>
    mutate(`fetchAnnouncementPost-${activeTable}`)
}

export const { FetchAnnouncementPosts } = AnnouncementsMutate
